import { authRoles } from '../../auth/authRoles';
import Loadable from '../../components/Loadable';
import { lazy } from 'react';

const Employee = Loadable(lazy(() => import('./employee/Employee')));
const Attendance = Loadable(lazy(() => import('./attendance/Attendance')));
const Payroll = Loadable(lazy(() => import('./salary/Payroll')));

const payrollRoutes = [
  { path: '/payroll/employee', element: <Employee />, auth: authRoles.ADMIN },
  { path: '/payroll/attendance', element: <Attendance />, auth: authRoles.ADMIN },
  { path: '/payroll/salary', element: <Payroll />, auth: authRoles.ADMIN },
];

export default payrollRoutes;
